// extracted by mini-css-extract-plugin
module.exports = {"activityListItem":"_3pJnj","activityListItemDescription":"_2fTZa","descriptionTextWrapper":"_3fLIW","activityIconWrapper":"_2T7X1","withPadding":"_2JXfE"};